import { render } from "./TeamPointsGamesCardV2.vue?vue&type=template&id=a7478202&scoped=true"
import script from "./TeamPointsGamesCardV2.vue?vue&type=script&lang=js"
export * from "./TeamPointsGamesCardV2.vue?vue&type=script&lang=js"

import "./TeamPointsGamesCardV2.vue?vue&type=style&index=0&id=a7478202&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7478202"]])

export default __exports__